import { render, staticRenderFns } from "./3.vue?vue&type=template&id=0d3bc184&scoped=true&"
var script = {}
import style0 from "./3.vue?vue&type=style&index=0&id=0d3bc184&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3bc184",
  null
  
)

export default component.exports